export default __webpack_public_path__ + "continental.295fbc.svg";